<script setup lang="ts">
import { useGetProjects } from "@/stores/queries";
import ProjectItem from "@/components/projects/ProjectItem.vue";
import { computed, ref } from "vue";
import { ProjectStatus, type PaginationParams } from "@/types";
import type { DRPartialProject, Project } from "@/types";
import { useDeviceState } from "@/stores/DeviceState";
import { storeToRefs } from "pinia";
import HomepageSection from "./HomepageSection.vue";

const deviceState = useDeviceState();
const { isOnline } = storeToRefs(deviceState);

const filters = ref({
  status: [ProjectStatus.IN_PROGRESS],
});

const pagination = ref<PaginationParams>({
  skip: 0,
  take: 100,
  sortBy: "createdAt",
  order: "desc",
});

const { data, localData } = useGetProjects(pagination, filters);
const projects = computed(() => {
  return data.value?.projects ?? localData.value ?? [];
});
</script>

<template>
  <HomepageSection
    :label="$t('dashboard:homepage.in-progress-projects')"
    :item-key="(item: DRPartialProject | Project) => item.id"
    :items="projects"
    :empty-text="$t('dashboard:homepage.no-in-progress-projects')"
  >
    <template #item="{ item, display }">
      <ProjectItem :project="item" :readonly="!isOnline" :display="display" />
    </template>
  </HomepageSection>
</template>

<style lang="scss" scoped></style>
